import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, SearchIcon, XIcon } from 'lucide-react';
import { DesktopNav } from './nav/DesktopNav';
import { MobileNav } from './nav/MobileNav';
import { Logo } from './Logo';
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-line bg-paper/95 backdrop-blur-sm" data-id="element-76" data-mp="2nllk4nedrsra">
      <div className="mx-auto flex max-w-shell items-center gap-6 px-6 py-4 lg:px-10" data-id="element-77" data-mp="2rl46lnluobw8">
        <Link to="/" className="flex shrink-0 items-center gap-3 text-olive transition-opacity duration-200 ease-soft hover:opacity-75" aria-label="Santa Barbara With Kids — home" data-id="element-78" data-mp="2wkqmk4t2c68q">
          <Logo className="h-14 w-14" data-id="element-79" data-mp="369qkrlzqqxlv" />
        </Link>

        <div className="ml-auto lg:ml-6" data-id="element-80" data-mp="3ba4x3g8dktpp">
          <DesktopNav data-id="element-81" data-mp="3bbfxd62m3jc2" />
        </div>

        <div className="ml-auto flex items-center gap-3" data-id="element-82" data-mp="3b8blrnmthlbd">
          <Link to="/things-to-do" className="flex h-9 w-9 items-center justify-center rounded-full border border-line text-muted transition-colors duration-150 ease-soft hover:border-olive hover:text-ink" data-id="element-83" data-mp="3fcjd7skntfda">
            <span className="sr-only" data-id="element-84" data-mp="2ro47wb2ryvmz">Search the site</span>
            <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-85" data-mp="2mng9v5g4pej9" />
          </Link>
          <a href="#newsletter" className="label hidden rounded-full bg-ink px-6 py-3 text-paper transition-colors duration-150 ease-soft hover:bg-olive xl:block" data-id="element-86" data-mp="2hodfqg1ossq2">
            Newsletter
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" className="flex h-9 w-9 items-center justify-center rounded-full border border-line text-ink lg:hidden" data-id="element-87" data-mp="3ad12yh5zxs69">
            <span className="sr-only" data-id="element-88" data-mp="1y0kmewk5xvq">{open ? 'Close menu' : 'Open menu'}</span>
            {open ? <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="3t9sj4hq8rr63" /> : <MenuIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="1rew5ycgv8hoi" />}
          </button>
        </div>
      </div>

      {open && <MobileNav onNavigate={() => setOpen(false)} data-id="element-91" data-mp="1wequwah2yx6x" />}
    </header>;
}